<template>
  <div class="snow-switch">
    <b-form-checkbox :checked="value" @change="onChange" switch>
      <div class="d-flex align-items-center">
        <span class="text-dark fs-14 ml-3">
          {{ label }}
          <span v-if="required" class="text-negative-700">*</span>
        </span>
        <bp-tooltip v-if="info" class="d-flex" :text="info">
          <i class="ph ph-info ml-2 fs-16" />
        </bp-tooltip>
      </div>
    </b-form-checkbox>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean
    },
    label: {
      type: String
    },
    required: {
      type: Boolean
    },
    info: {
      type: String
    }
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
      this.$emit("change", val);
    }
  }
};
</script>
<style lang="scss" scoped>
.snow-switch {
  min-height: 32px;
  display: flex;
  align-items: center;
  ::v-deep {
    .custom-switch {
      z-index: 0;
      display: flex;
      padding-left: 32px;

      .custom-control-label {
        display: flex;
        align-items: center;
        &::before {
          box-shadow: none;
          left: -32px;
          width: 32px;
          height: 18px;
          border-radius: 9px;
          border-color: #cccccc;
          background-color: #cccccc;
        }
        &::after {
          top: 6px;
          left: -30px;
          width: 14px;
          height: 14px;
          border-radius: 100%;
          background-color: #fff;
        }
      }

      &:has(.custom-control-input:checked) {
        .custom-control-label {
          &::before {
            border-color: var(--blue);
            background-color: var(--blue);
          }
          &::after {
            transform: translateX(14px);
            background-color: #fff;
          }
        }
      }
    }
  }
}
</style>
